import { render, staticRenderFns } from "./AddFacture.vue?vue&type=template&id=4f8a5dde"
import script from "./AddFacture.vue?vue&type=script&lang=js"
export * from "./AddFacture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports